import React, { useState } from 'react';
import axios from 'axios';

import { Button } from '@/components/ui/button';

import { Textarea } from '@/components/ui/textarea';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
	const [errorFeedback, setErrorFeedback] = useState('');

	const handleRestartDashboard = () => {
		// reload the page and navigate to root
		window.location.href = '/';
	};

	const handleChangeFeedback = (e) => {
		setErrorFeedback(e.target.value);
	};

	const handleSubmitFeedback = async () => {
		try {
			await axios.post('/api/error/feedback', {
				feedbackMessage: errorFeedback,
				error: error.message,
				currentUrl: window.location.href,
			});

			// reload the page and navigate to root
			window.location.href = '/';
		} catch (err) {
			console.log({ err });
		}
	};

	return (
		<div className="bg-background min-h-screen flex flex-col md:flex-row-reverse justify-center items-center p-5 max-md:min-h-[var(--app-height)] max-md:pb-[max(1.25rem,var(--safe-bottom))] max-md:pt-[max(1.25rem,var(--safe-top))]">
			<div className="w-full sm:w-1/2 md:w-1/3 max-md:max-w-60">
				<img
					src="/img/error-graphic.png"
					alt="error-graphic"
					className="max-w-full h-auto"
				/>
			</div>
			<div className="w-full sm:w-1/2 md:w-1/3 mt-5 md:mt-0">
				<p className="text-4xl max-md:text-3xl">Oops, sorry!</p>
				<p className="text-base mt-2">
					Looks like we've run into a bit of a snag. Please let us
					know what happened and our team will be happy to take a
					closer look.
				</p>

				<Textarea
					rows={4}
					className="w-full rounded-md mt-4"
					placeholder="Enter your feedback here"
					aria-label="What happened?"
					onChange={handleChangeFeedback}
				/>

				<div className="mt-2 flex flex-row space-x-2 max-md:flex-col max-md:gap-2 max-md:space-x-0 max-md:[&>button]:h-11 max-md:[&>button]:w-full">
					<Button
						variant="default"
						disabled={!errorFeedback}
						type="submit"
						onClick={handleSubmitFeedback}
					>
						Submit Feedback
					</Button>

					<Button
						className="w-full rounded-md"
						onClick={handleRestartDashboard}
						variant="outline"
					>
						Restart Dashboard
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ErrorFallback;
